/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import type { ReactNode } from "react";

/** A list page's header: its title, and what can be started from it. */
export function PageHeader({ title, action }: { title: string; action?: ReactNode }) {
  return (
    <header className="enter flex min-h-11 flex-wrap items-center justify-between gap-4">
      <h1 className="font-display text-2xl leading-tight text-text-primary sm:text-[1.75rem]">{title}</h1>
      {action}
    </header>
  );
}
